// src/Api/RoleMaster.js
import axios from "axios";
import { Base_URL } from "../url";

export const saveRoleDetails = async (roleData) => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const userId = userDetails?.userId; 
    const response = await axios.post(
      `${Base_URL}/RoleMaster/CreateRole?UserName=${userId}`,
      roleData
    );
    console.log(response);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error saving role details!";
  }
};


export const fetchRoles = async () => {
  try {
    const response = await axios.get(`${Base_URL}/RoleMaster/GetAllRoles`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching items!";
  }
};